import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextInput } from '../../components/input'
import { useLocation } from 'react-router-dom'
import SettingsMenu from '../staticscreens/SettingsMenu'
import GoBack from '../../components/back/GoBack'
import { CreateClassBookingCountService, GetClassBookingCountService, UpdateClassBookingCountService } from '../../services/class_booking/classBookingCountServices'

function ClassBookingCount() {
 
  const [data,setdata] = useState({count:'',teacher_assign_count:''});  
  const [error,seterror] = useState({count:'',teacher_assign_count:''}); 

  const {state} = useLocation();

  useEffect(()=>{
    getdata()
  },[state])

   async function getdata() {
      const response = await GetClassBookingCountService()
      if(response?.data?.datas?.length > 0){
          let d = response?.data?.datas[0]
          setdata({...d})
      }
    }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
    if(!data.count){
      seterror({...error,count:'Count field is required *'})
    }else if(!data.teacher_assign_count){
      seterror({...error,teacher_assign_count:'This Count field is required *'})
    }else{
        let sendData = {...data}
        if(data?._id === undefined || data?._id === sendData){
        const response = await CreateClassBookingCountService(data)
        if (response.status === 200) {
          toast.success('Class Booking Count Created Successfully')
        }   
        if(response.status === 422){
          seterror({...error,count:response?.data?.errors?.count})
        } 
      }else{
        let sendData = {...data}
        const response = await UpdateClassBookingCountService(sendData,data?._id)
        if (response.status === 200) {
          toast.success('Class Booking Count Updated Successfully')
        }   
        if(response.status === 422){
           seterror({...error,count:response?.data?.errors?.count})
        } 
      }
      getdata()
  }
  }


  function resetform(){
    setdata({count:''})
    seterror({count:''})
  }
  
  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
    <div className='sm:w-full lg:w-72 px-4 pt-5' >


        <GoBack /> 

        <h6 className='font-[700]'>{(data?._id !== null && data?._id !== undefined) ? 'Edit' : 'Add'} Class Booking Count Template</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Class Booking Count Template</b> for your clients followup.</h6>
     
     <TextInput 
            label={'Count (Class Booking Session)'}  
            variant="standard"
            name="count"
            type="number"
            error={error.count}
            value={data.count}
            handlechange={handlechange}
            placeholder="Enter your count"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

      <TextInput 
            label={'Count (Person Trainer Booking Session for Teacher)'}  
            variant="standard"
            name="teacher_assign_count"
            type="number"
            error={error.teacher_assign_count}
            value={data.teacher_assign_count}
            handlechange={handlechange}
            placeholder="Enter your count"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>      


        <div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(data?._id !== null && data?._id !== undefined) ? "UPDATE CLASS BOOKING COUNT" : "ADD CLASS BOOKING COUNT"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default ClassBookingCount